import { createRouter,createWebHashHistory } from 'vue-router'
export const Layout = () => import("@/layout/index.vue");

export const constantRoutes = [
  {
    path: "/redirect",
    component: Layout,
    meta: { hidden: true },
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () => import("@/views/redirect/index.vue"),
      },
    ],
  },
  {//首页
    path: "/",
    name: "/dashboard",
    component: Layout,
    redirect: "/dashboard",
    meta:{
      hidden: false,
      sideBar: true,
      keepAlive: true,
    },
    children: [
      {
        path: "dashboard",
        component: () => import("@/views/dashboard/index.vue"),
        name: "Dashboard", // 用于 keep-alive, 必须与SFC自动推导或者显示声明的组件name一致
        // https://cn.vuejs.org/guide/built-ins/keep-alive.html#include-exclude
        meta: {
          title: "首页",
          icon: "home_icon",
          keepAlive: true,
          alwaysShow: false,
        },
      }
    ],
  },
  {//模板库
    path: "/tplLibrary",
    name: "/tplLibrary",
    component: Layout,
    redirect: "/tplLibrary/tplList",
    meta:{
      hidden: false,
      sideBar: true,
      keepAlive: true,
    },
    children: [
      {
        path: "tplList",
        component: () => import("@/views/tplLibrary/index.vue"),
        name: "TplLibrary", // 用于 keep-alive, 必须与SFC自动推导或者显示声明的组件name一致
        // https://cn.vuejs.org/guide/built-ins/keep-alive.html#include-exclude
        meta: {
          title: "模板库",
          icon: "tpl_icon",
          keepAlive: true,
        },
      }
    ]
  },
  {//数字人库
    path: "/dhLibrary",
    name: "/dhLibrary",
    component: Layout,
    redirect: "/dhLibrary/dhList",
    meta:{
      hidden: false,
      sideBar: true,
      keepAlive: true,
    },
    children: [
      {
        path: "dhList",
        component: () => import("@/views/dhLibrary/index.vue"),
        name: "DhList", // 用于 keep-alive, 必须与SFC自动推导或者显示声明的组件name一致
        // https://cn.vuejs.org/guide/built-ins/keep-alive.html#include-exclude
        meta: {
          title: "数字人库",
          icon: "dh_icon",
          keepAlive: true,
        },
      }
    ]
  },
  {//我的创作
    path: "/myCreation",
    name: "/myCreation",
    component: Layout,
    redirect: "/myCreation/index",
    meta:{
      hidden: false,
      sideBar: true,
      keepAlive: true,
    },
    children: [
      {
        path: "index",
        component: () => import("@/views/myCreation/index.vue"),
        name: "MyCreation", // 用于 keep-alive, 必须与SFC自动推导或者显示声明的组件name一致
        // https://cn.vuejs.org/guide/built-ins/keep-alive.html#include-exclude
        meta: {
          title: "我的创作",
          icon: "my_icon",
          keepAlive: true,
        },
      }
    ]
  },
  {//资产管理
    path: "/assetManagement",
    name: "/assetManagement",
    component: Layout,
    redirect: "/assetManagement/index",
    meta:{
      hidden: false,
      sideBar: true,
      keepAlive: true,
    },
    children: [
      {
        path: "index",
        component: () => import("@/views/assetManagement/index.vue"),
        name: "AssetManagement", // 用于 keep-alive, 必须与SFC自动推导或者显示声明的组件name一致
        // https://cn.vuejs.org/guide/built-ins/keep-alive.html#include-exclude
        meta: {
          title: "资产管理",
          icon: "property_icon",
          keepAlive: true,
        },
      }
    ]
  },
  {//用户信息
    path: '/accountInfo',
    name: 'accountInfo',
    component: Layout,
    redirect: "/accountInfo/index",
    meta:{
      hidden: true,
      sideBar: false
    },
    children: [
      {
        path: "index",
        component: () => import('@/views/account/AccountInfo.vue'),
        name: "AccountInfo", // 用于 keep-alive, 必须与SFC自动推导或者显示声明的组件name一致
        // https://cn.vuejs.org/guide/built-ins/keep-alive.html#include-exclude
      }
    ]
  },
  {//用户协议
    path: '/privacyPage',
    name: 'privacyPage',
    component: Layout,
    redirect: "/privacyPage/agreement",
    meta:{
      hidden: true,
      sideBar: false
    },
    children: [
      {
        path: "agreement",
        component: () => import('@/views/privacyPage/agreement.vue'),
        name: "agreement", // 用于 keep-alive, 必须与SFC自动推导或者显示声明的组件name一致
        // https://cn.vuejs.org/guide/built-ins/keep-alive.html#include-exclude
      },
      {
        path: "privacy",
        component: () => import('@/views/privacyPage/privacy.vue'),
        name: "privacy", // 用于 keep-alive, 必须与SFC自动推导或者显示声明的组件name一致
        // https://cn.vuejs.org/guide/built-ins/keep-alive.html#include-exclude
      }
    ]
  },
  {//编辑页
    path: '/edit',
    name: 'Edit',
    meta:{
      title:'编辑页',
      hidden: true,
    },
    component: () => import('../views/editPage/index.vue')
  }
]
// process.env.BASE_URL
const router = createRouter({
  // history: createWebHistory(),
  history: createWebHashHistory(process.env.BASE_URL),//修改后
  routes: constantRoutes,
  // 刷新时，滚动条位置还原
  scrollBehavior: () => ({ left: 0, top: 0 }),
})

export default router
